<script>
    import {mapGetters, mapState} from 'vuex';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import SliderMixin from "../../../author/pagesbuilder/mixins/SliderMixin";
    import FiltersMixin from "../../../author/pagesbuilder/mixins/FiltersMixin";
    import RowsMixin from "../../../author/pagesbuilder/mixins/RowsMixin";

    export default {
        name: "SubscriptionCardsComponent",
        mixins: [
            AnimationsMixin,
            RowsMixin,
            FiltersMixin,
            SliderMixin
        ],
        data () {
            return {
                componentType: "subscription-cards",
                currentRenderData: {}
            }
        },
        computed : {
            ...mapState('products', ['subscriptions','courses']),
            ...mapGetters('user', ['isAdmin']),
            availableCards () {
                return [
                    {
                        cardFilename : "subscriptioncard1",
                        forSectionTemplates: ["Subscriptions1"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/subscriptioncard1.jpg"
                    },
                    {
                        cardFilename: "subscriptioncard2",
                        forSectionTemplates: ["Subscriptions2"],
                        thumbnail: this.imagePath + "/author/images/pagesbuilder/subscriptioncard2.jpg"
                    },
                    {
                        cardFilename: "subscriptioncard3",
                        forSectionTemplates: ["Subscriptions3"],
                        thumbnail: this.imagePath + "/author/images/pagesbuilder/subscriptioncard3.jpg"
                    },
                    {
                        cardFilename: "subscriptioncard4",
                        forSectionTemplates: ["Subscriptions4"],
                        thumbnail: this.imagePath + "/author/images/pagesbuilder/subscriptioncard4.jpg"
                    },
                    {
                        cardFilename: "subscriptioncard5",
                        forSectionTemplates: ["Subscriptions5"],
                        thumbnail: this.imagePath + "/author/images/pagesbuilder/subscriptioncard5.jpg"
                    }
                ]
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: 'basicComponentTemplate',
                    cardType: this.getDefaultCardType,
                    primaryFilterKey: 'byAll',
                    secondaryFilterKey: "",
                    styles: null,
                    rows: 1, // this is the currentPage. increments on every click of load more
                    cardsPerRow: 3, // how many cards will load on each page
                    limitAmountOfCards: true, // flag that enables pagination on cards rendering
                    cardsLoadOption: 'load-more',
                    itemVisibilitySettings: null
                }
            },
            getDefaultCardType () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;
                let cardTypeData = this.availableCards.find(cardData => cardData.forSectionTemplates.includes(sectionTemplateId));

                if (sectionState && cardTypeData) {
                    return cardTypeData.cardFilename;
                }

                return this.availableCards[0] ? this.availableCards[0].cardFilename : "";
            },
            getActionTriggerComponentsData () {
                return [
                    {
                        label : this.translations.load_more,
                        display: this.currentRenderData.data && (this.currentRenderData.rows * this.currentRenderData.cardsPerRow < this.currentRenderData.data.length),
                        template: "load-more",
                        executableFunction : this.loadMoreClicked
                    }
                ]
            },
            getFiltersConfig () {
                return [
                    {
                        filteringKey: "byAll",
                        filteringFunction: null,
                        filterAvailable: true,
                        label: "All",
                        translatedLabel: this.translations.subscriptions
                    },
                    {
                        filteringKey: "byCustomList",
                        filteringFunction: this.filterSubscriptionsByCustomList,
                        filterAvailable: true,
                        translatedLabel: "",
                        label: "Custom List",
                        dataSource: this.removePrivateAndArchived(this.subscriptions).map( subscription => {
                            return {
                                label: subscription.title,
                                value: subscription.titleId
                            }
                        }),
                    }
                ]
            },
            translations(){
                return {
                    "course": this.$t('common.course'),
                    "courses": this.$t('common.courses'),
                    "day": this.$t('common.day'),
                    "days": this.$t('common.day'),
                    "trial": this.$t('common.trial'),
                    "buttonText": this.$t('common.select'),
                    'subscriptions' : this.$t('account.subscriptions'),
                    "load_more": this.$t('blog.load_more'),
                }
            }
        },
        methods : {
            loadMoreClicked () {},
            handleActionTrigger (componentName) {
                this.getActionTriggerComponentsData.find( data => {
                    if(data.template === componentName && data.executableFunction) {
                        data.executableFunction.call(null);
                        return true;
                    }
                })
            },
            filterSubscriptionsByCustomList (subscriptions,list) {
                return subscriptions.filter((subscription) => {
                    return list.includes(subscription.titleId);
                });
            },
            editSubscriptionsData (subsData) {
                let newData = copyJson(subsData);
                newData = this.addCourseTitlesToSubs(newData);
                newData = this.removePrivateAndArchived(newData);
                newData = this.addTranslations(newData);
                if (this.myData.primaryFilterKey) {
                    newData = this.applySelectedFilters(newData)
                }
                newData = this.addSubscriptionCardLink(newData);

                return newData;
            },
            removePrivateAndArchived (subscriptions) {
                return subscriptions.filter((subscription) => {
                    // draft subscriptions have access: private, archived subscriptions have access: view-locked
                    return subscription.access === 'public' ;
                })
            },
            addCourseTitlesToSubs (subscriptions) {
                return subscriptions.map((subscription) => {
                    if (subscription.products && subscription.products.courses) {
                        subscription.products.courses.forEach( courseTitleId => {

                            if (!subscription.products.courseTitles) {
                                subscription.products.courseTitles = [];
                            }

                            let courseData = this.courses.find( course => course.titleId === courseTitleId);
                            if (courseData && !subscription.products.courseTitles.includes(courseData.title)) {
                                subscription.products.courseTitles.push(courseData.title);
                            }
                        })
                    }

                    return subscription;
                });
            },
            addSubscriptionCardLink (subscriptions) {
                return subscriptions.map(subscriptionData => {
                    return {
                        ...subscriptionData,
                        cardLink: this.enableHref ? `/subscription/${subscriptionData.titleId}` : 'javascript:void(0)',
                    }
                });
            },
            applySelectedFilters(subscriptions) {
                let primaryKey = this.componentData.primaryFilterKey;
                let secondaryKey = this.componentData.secondaryFilterKey;

                this.getFiltersConfig.find( filterData => {
                    if (primaryKey === filterData.filteringKey && filterData.filteringFunction ) {
                        subscriptions = filterData.filteringFunction.call(null,subscriptions,secondaryKey);
                        return true;
                    }
                });

                return subscriptions;
            },
            addTranslations(subscriptions) {                
                return subscriptions.map((subscription) => {
                    subscription.interval_type_name = subscription.interval > 1  ? this.$t('common.' + subscription.interval_type + 's') : this.$t('common.' + subscription.interval_type);
                    return subscription;
                });
            },
            renderComponent () {
                this.renderInProgress = true;

                let subscriptions = this.editSubscriptionsData(this.subscriptions);
                let amountOfCards = subscriptions.length;
                let cardsPerPage = (this.componentData.cardsPerRow > amountOfCards || !this.componentData.limitAmountOfCards) ? amountOfCards : this.componentData.cardsPerRow;

                let renderData = {
                    ...this.componentData,
                    data: subscriptions,
                    amountOfCards,
                    translations: this.translations,
                    cardsPerRow: cardsPerPage,
                };


                if (subscriptions.length < 1) {
                    renderData.template = 'nocontentmessage';
                    renderData.data = {
                        content: "No subscriptions have been created yet.",                        
                    }

                   if (this.isAdmin) {
                        renderData.template = 'nocontentmessage_author_subscriptioncards';
                        renderData.data.placeholderImageUrl = '/images/placeholders/subscriptions.jpg';
                    }
                }

                this.currentRenderData = renderData;


                this.renderTemplate(renderData.template, renderData).then(output => {
                    this.componentNode.innerHTML = output;
                    if (subscriptions.length < 1) {
                        this.handleNoSubscriptions();
                    }

                    this.addListeners();
                    this.renderingCompleted(renderData);
                    this.handleSliderCreation(renderData);
                });
            },
            addListeners() {

            },
            handleNoSubscriptions(){
                if (!this.isAdmin) {
                    this.componentNode.innerHTML = '';
                }
            },

            getFilterOptions () {
                let choices = [];
                choices.push({ label: "All", value : "byAll" });
                for (const sub of this.subscriptions) {
                    if (sub.hasOwnProperty('title') && sub.hasOwnProperty('titleId') && sub.access!=='private') {
                        choices.push({ label: sub.title, value : sub.titleId })
                    }
                }
                choices.push({ label: "Custom list", value : "byCustomList" });

                return choices;
            }
        },
        watch : {
            "myData.cardType": {
                handler (newVal, oldVal){
                    // console.log(" 1 cardType newVal, oldVal: " , newVal, oldVal , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.primaryFilterKey": {
                handler (newVal, oldVal){
                    // console.log(" 2 primaryFilterKey newVal, oldVal: " , newVal, oldVal , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.cardsPerRow": {
                handler (newVal, oldVal){
                    // console.log("3 cardsPerRow newVal, oldVal: " , newVal, oldVal  , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.rows": {
                handler (newVal, oldVal){
                    // console.log("4 rows newVal, oldVal: " , newVal, oldVal  , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.cardsLoadOption": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.secondaryFilterKey": {
                handler (newVal, oldVal){
                    // console.log("6 secondaryFilterKey newVal, oldVal: " , newVal, oldVal  , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "subscriptions" : {
                deep: true,
                handler () {
                    this.debouncedRenderComponent();
                }
            }
        },
    }
</script>
